export const SET_LIST = "calendar/SET_LIST";
export const SET_CALENDAR = "calendar/SET_CALENDAR"